/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Shot_MobileInputs */

const en_mk_shot_mobile = /** @type {(inputs: Mk_Shot_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KerjaBareng on a phone: the issue list stays readable with no sideways scrolling.`)
};

const id_mk_shot_mobile = /** @type {(inputs: Mk_Shot_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tampilan KerjaBareng di layar ponsel: daftar issue tetap terbaca tanpa geser ke samping.`)
};

/**
* | output |
* | --- |
* | "KerjaBareng on a phone: the issue list stays readable with no sideways scrolling." |
*
* @param {Mk_Shot_MobileInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_shot_mobile = /** @type {((inputs?: Mk_Shot_MobileInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Shot_MobileInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_shot_mobile(inputs)
	return en_mk_shot_mobile(inputs)
});